module.exports = __webpack_public_path__ + "img/4.3e6b995f.jpg";